import axiosServices from '../utils/axios';
import { CREDITS_ESTIMATION_EVENTS } from '../utils/eventSchema';
const backendUrl = import.meta.env.VITE_BACKEND_URL;

export const fetchProducts = async () => {
  const response = await axiosServices.get(`${backendUrl}/products/`, {
    withCredentials: true,
  });
  return response.data;
};
export const fetchSubscriptionProducts = async () => {
  return [];
};
export const fetchMe = async () => {
  const response = await axiosServices.get(`${backendUrl}/me/`, {
    withCredentials: true,
  });
  return response.data;
};
export const upgradePlan = async (payload, workspaceId) => {
  // Determine active workspace ID
  const wsId = workspaceId || localStorage.getItem('activeWorkspaceId');
  const url = wsId
    ? `${backendUrl}/workspace/${wsId}/create-checkout-session/`
    : `${backendUrl}/create-checkout-session/`; // Fallback (legacy)

  const response = await axiosServices.post(url, payload, {
    withCredentials: true,
  });
  return response.data;
};
export const viewTransactions = async ({ query, workspaceId = null }) => {
  const url = `${backendUrl}/workspace/${workspaceId}/billing-portal/?return_url=${query}`;

  const response = await axiosServices.post(url);
  return response.data;
};

export const estimateCredits = async ({
  studyId,
  callType,
  noOfParticipants,
  noOfTranscripts,
  noOfOpenQuestions,
  processId,
  transcriptIds,
  trackEvent,
}) => {
  try {
    const transcriptCount = transcriptIds?.length || noOfTranscripts || 0;
    const response = {
      data: {
        credits_required: transcriptCount + 1,
        analysis_units_required: transcriptCount + 1,
      },
    };
    // Moved tracking event after the API response
    if (trackEvent) {
      trackEvent('credits_estimation', {
        ...CREDITS_ESTIMATION_EVENTS.CREDITS_ESTIMATION_COMPLETED,
        estimated_credits: response.data.credits_required,
        study_id: studyId,
        call_type: callType,
        participants_count: noOfParticipants,
        transcripts_count: transcriptCount,
        questions_count: noOfOpenQuestions,
        process_id: processId || '',
      });
    }

    return response.data;
  } catch (error) {
    console.error('Error estimating credits:', error);

    throw error;
  }
};
export const estimateCreditsForReAnalysis = async ({ payload }) => {
  const response = await axiosServices.post(
    `${backendUrl}/qualitative-study-reanalysis-estimate-credits/`,
    payload,
  );

  const callTypeMap = response?.data.reduce((acc, item) => {
    acc[item.call_type] = item;
    return acc;
  }, {});
  return callTypeMap;
};

export const getInterviewEstimate = async ({ studyId }) => {
  const response = await axiosServices.get(
    `${backendUrl}/get-interview-estimate/?study_id=${studyId}`,
  );
  return response.data;
};
